var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header" }, [
    _vm._m(0),
    _vm._v(" "),
    _vm.serverTime
      ? _c("div", { staticClass: "right" }, [
          _c("span", [_vm._v("TEMPO RESTANTE")]),
          _vm._v(" "),
          _vm.time ? _c("h1", [_vm._v(_vm._s(_vm.time))]) : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "progress-bar" }, [
            _c("div", { staticClass: "progress-bar-total" }),
            _vm._v(" "),
            _c("div", {
              staticClass: "progress-bar-elapsed",
              style: "width: " + _vm.percentageTimeLeft() + "%"
            })
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left" }, [
      _c("img", {
        staticClass: "cart",
        attrs: { src: "/static/carrinho.svg" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "header-text" }, [
        _vm._v("FINALIZAR"),
        _c("br"),
        _vm._v(" COMPRA")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29db6603", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29db6603","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Checkout/Payable/OrderComponents/Header.vue
// module id = null
// module chunks = 